import React from 'react'
import PropTypes from 'prop-types'

const FixedSize = ({ restrict, children }) => (
    <div className="fixed-size-container">
        <div className="fixed-size">
            <div className={restrict === true ? 'fixed-size-restrict' : ''}>
                {children}
            </div>
        </div>
    </div>
)

FixedSize.defaultProps = {
    restrict: true
}

FixedSize.propTypes = {
    children: PropTypes.object,
    restrict: PropTypes.bool
}

export default FixedSize



// WEBPACK FOOTER //
// ./src/components/FixedSize.js